import classNames from 'classnames';
import { ReactElement } from 'react';

import { formatReported } from '~/utils/date/date';
import { ICeArchivedEntry, ICeEntry } from '~/services/api/communityEngagement/types';

import ArchivedSection from '~/ui/pages/Clients/reusable/CommunityEngagement/components/ArchivedSection';
import DocumentList from '~/ui/pages/Clients/reusable/CommunityEngagement/components/DocumentList';
import { formatEntryAmount } from '~/ui/pages/Clients/reusable/CommunityEngagement/helpers/formatAmount';
import ReadOnlyArchivedRow from './ReadOnlyArchivedRow';

import styles from './PlanEngagement.module.scss';

interface IEntryListProps {
  entries: ICeEntry[];
  archivedEntries: ICeArchivedEntry[];
}

const EntryList = ({ entries, archivedEntries }: IEntryListProps): ReactElement => (
  <div className={classNames(styles.block, styles.entries)}>
    {entries.length > 0 && (
      <>
        <h4 className={styles.blockTitle}>Entries</h4>
        <div>
          {entries.map(entry => (
            <div key={entry.id} className={styles.entry}>
              <div className={styles.entrySummary}>
                <span className={styles.entryAmount}>
                  {formatEntryAmount(entry.minutesWorked, entry.currencyEarned)}
                </span>
                <span className={styles.entryReported}>{formatReported(entry)}</span>
              </div>
              <div className={styles.entryDocuments}>
                <DocumentList documents={entry.documents} />
              </div>
            </div>
          ))}
        </div>
      </>
    )}
    {archivedEntries.length > 0 && (
      <ArchivedSection>
        {archivedEntries.map(archived => (
          <ReadOnlyArchivedRow
            key={archived.id}
            title={formatEntryAmount(archived.minutesWorked, archived.currencyEarned)}
            subtitle={formatReported(archived)}
          />
        ))}
      </ArchivedSection>
    )}
  </div>
);

export default EntryList;
